import React, { FC } from "react";
import { useTranslations } from "next-intl";
import { NoDataIcon, NoDataUkraineIcon } from "@/components/assets/icons";
import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";

type TProps = {
  title: string;
  subtitle?: string;
};

const EmptyData: FC<TProps> = ({ title, subtitle }) => {
  const theme = useTheme();
  const t = useTranslations();

  return (
    <div className="mt-8 flex w-full flex-col items-center justify-center">
      {theme === Theme.UK ? <NoDataUkraineIcon /> : <NoDataIcon />}
      <div className="mt-8 flex flex-col justify-center">
        <p className="p-[40px] text-center text-2xl font-bold text-black">
          {t(title)}
        </p>
        {subtitle && (
          <div className="flex w-full justify-center">
            <p className="w-full max-w-[27.68rem] text-center text-lg font-normal leading-normal text-[#949494]">
              {t(subtitle)}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export { EmptyData };
